import baseMixin from './baseMixin'
import {
    styler,
    tween,
    spring,
    composite,
    easing,
    chain,
    delay
} from 'popmotion'

export default {
    mixins: [baseMixin],

    beforeCreate() {
        this.baseElementQueryString = 'data-ethics-graphic'
    },

    methods: {
        setStyler() {
            this.styler = styler(this.baseElement.querySelector('#de-shield'))
            this.rayStyler = styler(this.baseElement.querySelector('#rays'))
        },

        initAction() {
            return tween({
                from: { opacity: 1 },
                to: { opacity: 0 }
            })
        },

        animationAction() {
            const shield = spring({
                from: { scale: 0.8, y: 20, rotate: 15 },
                to: { scale: 1, y: 0, rotate: 0 },
                mass: 2
            })
            const opacity = tween({
                from: { opacity: 0 },
                to: { opacity: 1 }
            })
            const rays = tween({
                from: { opacity: 0, scale: 1.3, rotate: -10 },
                to: { opacity: 1, scale: 1, rotate: 0 },
                duration: 600,
                ease: easing.linear
            })
            return composite({
                shield,
                opacity,
                rays: chain(delay(400), rays)
            })
        },

        initReaction(values) {
            this.styler.set(values)
            this.rayStyler.set(values)
        },

        animationReaction(values) {
            const { shield, opacity, rays } = values
            shield && this.styler.set(shield)
            opacity && this.styler.set(opacity)
            rays && this.rayStyler.set(rays)
        }
    }
}
